export default import.meta.ROLLUP_FILE_URL_48o3_vv615k_nohwGyv4Rw